<template>
  <div class="container">
    <b-form>
      <div class="form-group">
      <label for="login">Name</label>
      <b-input id="login" v-model="user.login" ></b-input>
      <label for="name">Benutzername</label>
      <b-input v-model="user.name"></b-input>
        <b-form-checkbox
          v-model="user.type"
          value="admin"
          id="type"
          unchecked-value="user"
        >
          {{ $trans.user.is_admin }}
        </b-form-checkbox>
      </div>
      <div class="form-group">
      <b-button class="btn btn-success" @click="change()">{{ $trans.main.button_save }}</b-button>
      </div>
      <div class="form-group">
      <h4>Neues Passwort</h4>
      <b-form-row>
        <div class="col">
          <b-input v-model="user.password"></b-input>
        </div>
        <div class="col">
          <b-button class="btn btn-success" @click="newPassword()">{{ $trans.main.button_save }}</b-button>
        </div>
      </b-form-row>
      </div>
    </b-form>
  </div>

</template>

<script>
import axios from 'axios'

export default {
  name: 'LocalUsers',
  data () {
    return {
      user: {
        id: '',
        name: '',
        login: '',
        password: ''
      }
    }
  },
  created () {
    this.getUser()
  },
  methods: {
    async deleteUser () {
      axios({
        url: 'users/' + this.user.id,
        method: 'DELETE'
      }).then(response => {
        this.getUsers()
      }).catch(error => {
        console.log(error.response.data)
      })
    },
    async newPassword () {
      axios({
        url: 'users/' + this.user.id + '/password',
        data: {password: this.user.password},
        method: 'PUT'
      }).then(response => {
        this.$router.back()
      }).catch(error => {
        console.log(error.response.data)
      })
    },
    async change () {
      axios({
        url: 'users/' + this.user.id,
        data: {
          login: this.user.login,
          name: this.user.name,
          type: this.user.type
        },
        method: 'PUT'
      }).then(response => {
        this.$router.back()
      }).catch(error => {
        console.log(error.response.data)
      })
    },
    async getUser () {
      return new Promise((resolve, reject) => {
        axios({
          url: 'users/' + this.$route.params.id,
          method: 'GET'
        }).then(response => {
          this.user = response.data.user
        }).catch(error => {
          console.log(error.response.data)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/users/UserEdit.vue